import { JSONSchema7, JSONSchema7Type } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';
import { ConditionalRuleConfig } from '../../Shared/RulesEngine/types';

export default (currentVersion: JSONSchema7): JSONSchema7 => {
  const properties = currentVersion.properties as JSONSchema7Properties;

  properties['version'].default = 5;

  properties['rules'].default = (
    properties['rules'].default as unknown as ConditionalRuleConfig[]
  ).map((rule) => {
    rule.utilize = rule.utilize
      ? rule.utilize.replace(/,/g, "|")
      : rule.utilize;
    return rule;
  }) as unknown as JSONSchema7Type

  return {
    ...currentVersion,
    properties
  };
};
